import React, { useEffect, useMemo } from 'react';
import { useWizard } from '@leverege/ui-wizard';
import { Flex, Text, Pane } from '@leverege/ui-elements';
import { Attributes, ItemCard } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import Path from '@leverege/path';
import Util from "./Util.js";
const {
  t,
  tIcon
} = I18N.ns('pairing.imagine.PairSummary');
export default function PairSummary(props) {
  const {
    context,
    setHeader,
    setHeaderIcon,
    setNextText,
    wizardData
  } = useWizard();
  const {
    relationship,
    parentRelationship,
    attribute
  } = context;
  const assetName = relationship.parentBlueprint.name;
  const tagName = relationship.blueprint.name;
  const asset = wizardData.asset.obj;
  const tag = wizardData.tag.obj;
  useEffect(() => {
    setHeader(t('header'));
    setHeaderIcon(tIcon('headerIcon'));
    setNextText(t('pair'));
  }, []);
  const assetRenderers = useMemo(() => {
    const pairingMeta = attribute?.source?.attribute?.metadata?.pairing?.pair?.asset;
    let extraFields = pairingMeta?.extraFields;
    extraFields = extraFields || [{
      name: 'name'
    }];
    const model = Util.getItemModelFromAttributes(extraFields, {
      objectType: parentRelationship.objectType
    });
    const target = {
      ...asset,
      data: {
        ...asset.data,
        data: wizardData.asset.data
      }
    };
    const nameAttr = Attributes.getAttribute('name', parentRelationship.objectType);
    if (nameAttr) {
      Path.set(nameAttr.source?.field, target.data, nameAttr.get(asset.data));
    }
    return /*#__PURE__*/React.createElement(ItemCard, {
      model: model,
      context: {
        target: [target]
      }
    });
  }, []);
  const tagRenderers = useMemo(() => {
    const pairingMeta = attribute?.source?.attribute?.metadata?.pairing?.pair?.tag;
    let extraFields = pairingMeta?.extraFields;
    extraFields = extraFields || [{
      name: 'name'
    }];
    const model = Util.getItemModelFromAttributes(extraFields, {
      objectType: relationship.objectType
    });
    const target = {
      ...tag,
      data: {
        ...tag.data,
        data: wizardData.tag.data
      }
    };
    const nameAttr = Attributes.getAttribute('name', relationship.objectType);
    if (nameAttr) {
      Path.set(nameAttr.source?.field, target.data, nameAttr.get(tag.data));
    }
    return /*#__PURE__*/React.createElement(ItemCard, {
      model: model,
      context: {
        target: [target]
      }
    });
  }, []);
  return /*#__PURE__*/React.createElement(Flex, {
    variant: "colL"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "formTitle"
  }, t('title')), /*#__PURE__*/React.createElement(Text, {
    variant: "bodySmall"
  }, t('description')), /*#__PURE__*/React.createElement(Pane, {
    layout: "flex:colS",
    style: {
      marginTop: 10,
      '--color-detailEvenRow': 'transparent',
      '--color-detailOddRow': 'rgba(0, 0, 0, 0.03)'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "detailValue"
  }, t('assetDetails', {
    assetName
  })), /*#__PURE__*/React.createElement(Pane, {
    variant: "detailCardNoShadow"
  }, assetRenderers)), /*#__PURE__*/React.createElement(Pane, {
    layout: "flex:colS",
    style: {
      '--color-detailEvenRow': 'transparent',
      '--color-detailOddRow': 'rgba(0, 0, 0, 0.03)'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "detailValue"
  }, t('tagDetails', {
    tagName
  })), /*#__PURE__*/React.createElement(Pane, {
    variant: "detailCardNoShadow"
  }, tagRenderers)));
}
PairSummary.TYPE = 'imagine.pairing.PairSummary';